import { createIcon } from '../icon'
import CountdownClock from '@/components/atoms/svg/CountdownClock'

export const CountdownClockDefault = createIcon(CountdownClock)
